import { createSlice } from '@reduxjs/toolkit'
import { APP_CONFIG } from 'constants/app.constant'
import { getConfigs, getCurrencies } from 'features/common'

const initialState = {
    configs: {},
    currencies: [],
    loading: false,
    error: null,
}

const configSlice = createSlice({
    name: 'config',
    initialState,
    reducers: {
        setConfigs: (state, action) => {
            state.configs = action.payload
            state.loading = false
            state.error = null
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        },
        setError: (state, action) => {
            state.error = action.payload
            state.loading = false
        },
        setCurrencies: (state, action) => {
            state.currencies = action.payload
        },
    },
})

export const { setConfigs, setLoading, setError, setCurrencies } =
    configSlice.actions

export const fetchConfigs = () => async (dispatch) => {
    try {
        dispatch(setLoading(true))
        const response = await getConfigs({
            excludeTypes: JSON.stringify([APP_CONFIG.CANDIDATE_SKILL]),
        })

        // Process the data
        const configs = {}
        for (let i = 0; i < response.length; i++) {
            const item = response[i]
            if (!configs[item.type]) {
                configs[item.type] = [item]
            } else {
                configs[item.type] = [...configs[item.type], item]
            }
        }

        dispatch(setConfigs(configs))
    } catch (error) {
        console.log(error, 'error')
        dispatch(setError(error.message))
    }
}

export const fetchCurrencies = () => async (dispatch) => {
    try {
        const data = await getCurrencies()
        dispatch(setCurrencies(data))
    } catch (error) {
        console.log(error, 'error')
        dispatch(setError(error.message))
    }
}

export default configSlice.reducer
